import React from 'react';

//import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import {
  HashRouter as Router, // 或者是HashRouter、MemoryRouter
  Route,   // 这是基本的路由块
  Link,    // 这是a标签
  Switch ,  // 这是监听空路由的
  Redirect, // 这是重定向
  Prompt   // 防止转换
} from 'react-router-dom'


import routes from './model/router';


import MediaQuery from 'react-responsive';
import Mobile from './components/Mobile/Mobile';
import { max } from 'moment';



class App extends React.Component {
  render() {
    return (
      <Router >
      <div>
        <MediaQuery minDeviceWidth={1224}>
          {
            routes.map((route, key) => {
              if (route.exact) {
                console.log(route.exact);
                return <Route key={key} exact path={route.path}
                  render={props => (
                    <route.component {...props} routes={route.routes} />
                  )}
                />
              }
              else {
                return <Route key={key} path={route.path}
                  render={props => (
                    <route.component {...props} routes={route.routes} />
                  )}
                ></Route>
              }
            })
          }
        </MediaQuery>

        <MediaQuery maxDeviceWidth={1224}>
          { <Route path= "/" component={Mobile}></Route>}
        

        </MediaQuery>
        </div>
      </Router>
    );
  }
}

export default App;
